import { defaultOccupationGroupData } from '../../../../backend/config/classifiers/defaults/DefaultOccupationGroupData';
import { occupationGroupSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const occupationGroupEntityName = 'occupationGroup';
const occupationGroupColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { selectable: {
        type: 'boolean-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineOccupationGroupClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 4,
            columns: occupationGroupColumns,
            onMigrate: (params) => {
                if (params.oldData.selectable == null) {
                    params.oldData.selectable = true;
                }
                return params.oldData;
            },
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { selectable: params.data.selectable, search: [params.data.name, params.data.status].join(' ') });
            },
            onChangeSync: (context) => {
                context.invalidateAppState('occupationGroups');
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultOccupationGroupData,
        publicData: [
            {
                listRequest: {
                    filter: [
                        { column: 'selectable', op: '=', value: true },
                        { column: 'status', op: '=', value: 'active' },
                    ],
                    orderBy: [{ column: 'name' }],
                },
                mapValueDetailed: (item) => ({
                    value: item.id,
                    label: item.columns.name,
                }),
            },
        ],
    }, occupationGroupSchema);
}
